import { render, staticRenderFns } from "./dashboardPlaceContextMenu.vue?vue&type=template&id=25a07bae"
import script from "./dashboardPlaceContextMenu.vue?vue&type=script&lang=js"
export * from "./dashboardPlaceContextMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports